"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.centeredFlexStyles = exports.basePositionStyles = void 0;
const basePositionStyles = exports.basePositionStyles = {
  bottom: 0,
  left: 0,
  position: 'absolute',
  right: 0,
  top: 0
};
const centeredFlexStyles = exports.centeredFlexStyles = {
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  width: '100%'
};
